import React, { useEffect, useState } from 'react';
import ByobAddToCartButton from './ByobAddToCartButton.jsx';
import { FaCircleMinus } from "react-icons/fa6";

const ByobTray = ({trayData , handleRemoveFromTray , setTrayData}) => {

  const [trayTotalPrice , setTrayTotalPrice] = useState(0);
  const [discountedTotalPrice , setDiscountedTotalPrice] = useState(0);
  const [trayWarning , setTrayWarning] = useState('');
  const [bundleParentId, setBundleParentId] = useState('');
  const [bundleDiscountPercentage, setBundleDiscountPercentage] = useState(0);
  const [byobContentCardSettings, setByobContentCardSettings] = useState({});

  useEffect(() => {
      console.log("BYOB Content Card Settings", window.byobContentCardSettings);
      setByobContentCardSettings(window.byobContentCardSettings);
  }, []);


  useEffect(() => {
    const calculateTotalPrice = (trayData) => {
      return trayData.reduce((total, item) => {
        const price = parseFloat(item.price.replace('$', ''));
        return total + price;
      }, 0);
    };

    setTrayTotalPrice(calculateTotalPrice(trayData));
    setDiscountedTotalPrice(calculateTotalPrice(trayData) * (bundleDiscountPercentage / 100));
  }, [trayData]); 

  useEffect(() => {
    setTrayWarning(window.collectionData.byob_set_tray_warning);
    setBundleParentId(window.collectionData.tray_data);
    setBundleDiscountPercentage(window.collectionData.tray_discount_percentage)
  }, []);


  // Create an array of 5 tray slots
// If an item exists in trayData at the corresponding index, use that item
// Otherwise, fill the slot with null (representing an empty slot)
// This ensures we always have exactly 5 slots, filled with items or null
  const traySlots = Array(5).fill(null).map((_, index) => trayData[index] || null);

  useEffect(() => {
    console.log('Tray Data', trayData);
    setBundleParentId(window.collectionData.tray_data);
    setBundleDiscountPercentage(window.collectionData.tray_discount_percentage)

  }, [trayData]);


    return (
      <div className='sticky top-12 right-2 w-full py-3 bg-white opacity-100 text-white border-y-[1.5px] md:border-[1.5px] md:rounded-xl flex flex-col'>
          <div className='flex flex-row md:flex-col px-4 py-1'>
            { traySlots.map((item, index) => (
              <div key={ 'tray-' + index + '-' + item?.product_id} className='flex items-center'>
                { item ? (
                  <div className="mb-2 me-2 text-center block md:flex items-center justify-center">
                    <img src={item.image} alt={item.title}   className='object-contain h-[120px] w-[120px]' />
                    <div className="text-center">
                      <button className=" p-1 py-0 rounded-full"  onClick={() => handleRemoveFromTray(index)}>
                      <FaCircleMinus color='black' size={24}/>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className='h-[80px] rounded-lg md:h-[110px] w-auto md:w-full border-[1.5px] mb-0 md:mb-2 me-2 md:me-0 '>
                    empty slot
                  </div>
                )}
              </div>
            ) )}
          </div>

        <div className='flex flex-row md:flex-col justify-between items-center  mt-3 px-4'>

        {trayData.length < 3 ? (
          <ul className='text-black mb-2 me-2'>
            <li className="italic">{trayWarning}</li>
          {/* <li>${ (trayTotalPrice - discountedTotalPrice).toFixed(2)}</li> */}
          </ul>
        ) : (
          <ul className='text-black flex flex-row md:block gap-2'>
            <li className="line-through" style={{ color: byobContentCardSettings.msrp_price_color }}>${trayTotalPrice.toFixed(2)}</li>
            <li style={{ color: byobContentCardSettings.msrp_discounted_price_color }}>${ (trayTotalPrice - discountedTotalPrice).toFixed(2)}</li>
          </ul>
        ) }

         <div className="addToCartButtonContainer w-full text-end">
          <ByobAddToCartButton trayData={trayData}  setTrayData={setTrayData} discountedTotalPrice={discountedTotalPrice} bundleParentId={bundleParentId}/>  
         </div>
        </div>
      </div>
      

    )
}

export default ByobTray;